if (!customElements.get("product-form")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.hasChildNodes() && this.init();
    }
    init() {
      (this.form = this.querySelector(".js-product-form")),
        (this.form.querySelector('[name="id"]').disabled = !1),
        (this.cartDrawer = document.querySelector("cart-drawer")),
        (this.submitBtn = this.querySelector('[name="add"]')),
        "no-js" !== theme.settings.afterAtc &&
          this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }
    async handleSubmit(e) {
      if (
        window.location.pathname === theme.routes.cart ||
        (e.preventDefault(),
        "true" === this.submitBtn.getAttribute("aria-disabled"))
      )
        return;
      (this.errorMsg = null),
        this.setErrorMsgState(),
        this.submitBtn.setAttribute("aria-disabled", "true"),
        this.submitBtn.classList.add("is-loading"),
        this.submitBtn.setAttribute("disabled", "disabled");
      let s = new FormData(this.form),
        i = this.cartDrawer
          ? `${this.cartDrawer.dataset.section},cart-icon-bubble`
          : "cart-icon-bubble";
      s.append("sections_url", window.location.pathname),
        s.append("sections", i);
      try {
        let r = await fetch(`${theme.routes.cart}.js`);
        if (!r.ok) throw Error(r.status);
        let a = await r.json(),
          n = await fetch(theme.routes.cartAdd, {
            method: "POST",
            headers: {
              Accept: "application/javascript",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: s,
          }),
          o = await n.json(),
          d = "string" == typeof o.description ? o.description : o.message;
        if ((o.status && this.setErrorMsgState(d), !n.ok))
          throw Error(n.status);
        if ("page" === theme.settings.afterAtc)
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        else {
          t.updateCartIcon(o);
          let c = this.closest("quick-add-drawer");
          c && c.addedToCart(),
            setTimeout(() => {
              if (this.cartDrawer)
                this.cartDrawer.renderContents(
                  o,
                  !c && "drawer" === theme.settings.afterAtc
                );
              else if (window.location.pathname === theme.routes.cart) {
                let t = document.querySelector("cart-items");
                t &&
                  ("true" === t.dataset.empty
                    ? window.location.reload()
                    : t.refresh());
              }
            }, 700);
        }
        let u = await fetch(`${theme.routes.cart}.js`);
        if (!u.ok) throw Error(u.status);
        let h = await u.json(),
          l = a.items.filter((t) => t.variant_id === o.variant_id)[0];
        l
          ? this.dispatchEvent(
              new CustomEvent("on:line-item:change", {
                bubbles: !0,
                detail: {
                  cart: h,
                  variantId: o.variant_id,
                  oldQuantity: l.quantity,
                  newQuantity:
                    l.quantity === o.quantity ? l.quantity : o.quantity,
                },
              })
            )
          : this.dispatchEvent(
              new CustomEvent("on:cart:add", {
                bubbles: !0,
                detail: { cart: h, variantId: o.variant_id },
              })
            ),
          this.submitBtn.classList.add("is-success"),
          this.submitBtn.removeAttribute("aria-disabled"),
          setTimeout(() => {
            this.submitBtn.classList.remove("is-loading"),
              this.submitBtn.classList.remove("is-success"),
              this.submitBtn.removeAttribute("disabled");
          }, 2e3);
      } catch (b) {
        console.log(b),
          this.dispatchEvent(
            new CustomEvent("on:cart:error", {
              bubbles: !0,
              detail: { error: this.errorMsg.textContent },
            })
          ),
          this.submitBtn.classList.remove("is-loading"),
          this.submitBtn.classList.remove("is-success"),
          this.submitBtn.removeAttribute("disabled"),
          this.submitBtn.removeAttribute("aria-disabled"),
          this.cartDrawer && this.cartDrawer.refresh(!0);
      }
    }
    static updateCartIcon(t) {
      let e = document.getElementById("cart-icon-bubble");
      e.innerHTML = t.sections["cart-icon-bubble"];
    }
    setErrorMsgState(t = !1) {
      (this.errorMsg = this.errorMsg || this.querySelector(".js-form-error")),
        this.errorMsg &&
          ((this.errorMsg.hidden = !t), t && (this.errorMsg.textContent = t));
    }
  }
  customElements.define("product-form", t);
}
